module.exports = "https://static.energy5.com/_next/static/images/savings-c92e425d7ec7f18af2f705b0a5e5db71.png";